module.exports = __webpack_public_path__ + "media/images/undraw_winners_high_five-dd6d1469c33f50b87237d33ed022d0b4.png";